import { Component, OnInit } from '@angular/core';

@Component({
    standalone: false,
    selector: 'particle-comment-dialog',
  templateUrl: './comment-dialog.component.html',
  styleUrls: ['./comment-dialog.component.scss']
})
export class CommentDialogComponent implements OnInit {
  contextId: string;
  scopeInt: number;
  messageType: number;
  conversationType: number;
  data: any;
  constructor() {
    this.conversationType = 3;
    this.messageType = 0;
    this.scopeInt =1;
  }

  ngOnInit() {
    if (this.data && this.data.componentInfo && this.data.componentInfo.data) {
      this.contextId = this.data.componentInfo.data;

    }
  }

}
